<wizard-labeled-field label="Meeting Title" [size]="fieldSize">
    <wizard-tooltip>
        The Meeting title represents the subject of your meeting. Meeting Titles will appear in the meeting invite and
        calendar event sent to your attendees. Update the default meeting title by replacing with your own.
        <a href="https://faq.calendarhero.com/hc/en-us/articles/4430391624731-How-do-I-add-or-customize-a-meeting-Title-" target="_blank"
            >Learn More</a
        >
    </wizard-tooltip>
    <div class="ui icon input teal" [class.loading]="isLoading">
        <input
            type="text"
            placeholder="Title"
            name="title"
            [formControl]="meetingSubject"
            (keyup)="handleKeyup()"
        />
        <i *ngIf="isLoading" class="search icon"></i>
    </div>
</wizard-labeled-field>
